module.exports = __webpack_public_path__ + "media/images/icons/country_flags/un-bc6e9eb5b119f03cb2afe2e4cc0df558.svg";